export const Z_INDEX = {
  public_homeSearchWidget: 1,
  header: 2,
  bottomNavBar: 2,
  modalCookies: 3,
};
